import { render, staticRenderFns } from "./Precos.vue?vue&type=template&id=76c9b8e6&"
import script from "./Precos.vue?vue&type=script&lang=js&"
export * from "./Precos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports